// Registro dos mapas jogáveis (ordem = ordem de exibição).
import type { GameMap } from '../types';
import { buildAcademia } from './academia';
import { buildBeginner } from './beginner';
import { buildUtopia } from './utopia';
import { buildVulcao } from './vulcao';
import { buildZenite } from './zenite';

export interface MapEntry {
  slug: string;
  name: string;
  tier: number;
  build: () => GameMap;
}

export const MAPS: MapEntry[] = [
  { slug: 'surf_academia', name: 'surf_academia', tier: 1, build: buildAcademia },
  { slug: 'surf_beginner', name: 'surf_beginner', tier: 1, build: buildBeginner },
  { slug: 'surf_utopia', name: 'surf_utopia', tier: 2, build: buildUtopia },
  { slug: 'surf_vulcao', name: 'surf_vulcao', tier: 2, build: buildVulcao },
  { slug: 'surf_zenite', name: 'surf_zenite', tier: 3, build: buildZenite },
];
